import { Box, Radio } from '@mui/material';
import { AppContext } from 'contexts/AppContext';
import { useContext } from 'react';
import { FiberManualRecord, RadioButtonUnchecked } from '@mui/icons-material';

const CustomRadio = (props) => {
    const {styleGuide} = useContext(AppContext)
    const {label, checked, onChange} = props

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Radio
                icon={<RadioButtonUnchecked sx={{ color: styleGuide.color5 }} />}
                checkedIcon={
                    <Box
                        sx={{
                            position: 'relative',
                            width: 20,
                            height: 20,
                        }}
                    >
                        <RadioButtonUnchecked
                            sx={{
                                position: 'absolute',
                                color: styleGuide.color5, // border color
                                fontSize: 20,
                            }}
                        />
                        <FiberManualRecord
                            sx={{
                                position: 'absolute',
                                color: styleGuide.color16, // inner dot color
                                fontSize: 14,
                                top: 3,
                                left: 3,
                            }}
                        />
                    </Box>
                }
                checked={checked}
                onChange={onChange}
                size="small"
                sx={{
                    padding: 0,
                }}
            />

            {label}
        </Box>
    )
}

export default CustomRadio

